const About = () => {
  return (
    <div id="about">
      <p id="aboutText">
        This is not an actual landing page,this website has been created by Alex
        Hmar as a part of his web development{" "}
        <a href="#" target="_blank" rel="noreferrer noopener">
          Portfolio.
        </a>
        Images have been taken from{" "}
        <a href="https://icons8.com/" target="_blank" rel="noreferrer noopener">
          icons8.com.
        </a>
        Fonts provided by{" "}
        <a
          href="https://fonts.google.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Google Fonts.
        </a>
        This website has been made only for desktop and smartphone and doesn't
        support displays smaller than 320px or bigger than 1200px;
      </p>
    </div>
  );
};

export default About;
